import { Core, Decorative } from "@faire/design-tokens";
import { Row } from "@faire/web/slate/Layout";
import { Span, Typography } from "@faire/web/slate/Typography";
import { Money } from "@faire/web/ui/Money";
import React from "react";
import styled from "styled-components";

import { PerStyleVariationMapBuilder } from "@faire/retailer/features/OpenSizing/PerStyleVariationMapBuilder";
import { showProductPromotions } from "@faire/retailer/lib/showProductPromotions";

export const OpenSizingVariationLabel: React.FC<{
  variation: PerStyleVariationMapBuilder.IPerStyleOptionVariation;
}> = ({ variation }) => {
  const label = variation.size;
  const disabled = variation.inventory === 0;
  const costSuffix = variation.wholesalePrice;
  const promoPrice = variation.promoPrice;

  return (
    <Row align="center" gap="1x">
      <Typography data-test-id={`open-sizing-size-${label}`}>
        {disabled ? <StrikeThrough>{label}</StrikeThrough> : label}
      </Typography>
      {costSuffix ? (
        <Typography
          variant="labelSansRegular"
          color={Core.text.subdued}
          data-test-id={`open-sizing-${label}-variation-suffix`}
        >
          (
          {showProductPromotions(promoPrice) ? (
            <>
              <StrikeThrough>
                <Money money={costSuffix} />
              </StrikeThrough>
              <Span color={Decorative.shade.orange}>
                {" "}
                <Money money={promoPrice.discounted_item_price} />
              </Span>
            </>
          ) : (
            <Money money={promoPrice?.discounted_item_price ?? costSuffix} />
          )}
          )
        </Typography>
      ) : undefined}
    </Row>
  );
};

const StrikeThrough = styled.span`
  text-decoration: line-through;
  color: ${Core.text.subdued};
`;
